import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const printFluidBalance = (gpdsId, fromSelector, toSelector, printButton, buttonCloseId) => {
  const selectFrom = document.querySelector(fromSelector);
  const selectTo = document.querySelector(toSelector);
  const button = document.querySelector(printButton);
  const buttonClose = document.querySelector(buttonCloseId);

  if (selectFrom.value && selectTo.value) {
    button.onclick = () => {
      const baseUrl = `${window.config.ePersonamService.ePersonamHost}/${window.locale}`;
      const printFluidBalanceUrl = `${baseUrl}/reports/generate_report.json?guest_period_data_set_id=${gpdsId}&from=${selectFrom.value}&to=${selectTo.value}&worker=ShowFluidBalancePdfWorker`;
      apiConnector()
        .get(printFluidBalanceUrl)
        .then((response) => {
          eventBus.$emit('generateReport', response.data);
        });
      buttonClose.click();
    };
  } else {
    button.disabled = true;
  }
};

const init = (gpdsId, fromSelector, toSelector, printButton, buttonCloseId) => {
  try {
    printFluidBalance(gpdsId, fromSelector, toSelector, printButton, buttonCloseId);
  } catch (e) {
    errorManager(e);
  }
};

window.PrintFluidBalanceReport = {
  init: init,
};
